import { useQuery } from "@tanstack/react-query"
import { createFileRoute } from "@tanstack/react-router"
import { fetchTenantUsage } from "../../lib/api"
import { queryKeys } from "../../lib/query-keys"
import { requireAdmin } from "../../lib/route-guards"
import { TenantUsageView } from "./-tenant-usage/TenantUsageView"

export const Route = createFileRoute("/_auth/tenant-usage")({
  beforeLoad: requireAdmin,
  component: TenantUsagePage,
})

function TenantUsagePage(): React.JSX.Element {
  const { data, isLoading } = useQuery({
    queryKey: queryKeys.admin.tenantUsage(),
    queryFn: fetchTenantUsage,
  })

  return <TenantUsageView rows={data ?? []} isLoading={isLoading} />
}
